import React from 'react';
import { StyledSystemProps } from '@creditas-ui/react';
import { useLockBodyScroll } from '@/hooks/helpers/useLockBodyScroll';
import { Overlay, Modal } from './SubMenu.style';

interface SubMenuBaseProps {
  children: React.ReactNode;
}

type SubMenuElProps = React.HTMLAttributes<HTMLDivElement>;

type SubMenuProps = SubMenuBaseProps & SubMenuElProps & StyledSystemProps;

const SubMenu = ({ children, ...props }: SubMenuProps): JSX.Element => {
  useLockBodyScroll();

  return (
    <Overlay {...props}>
      <Modal>{children}</Modal>
    </Overlay>
  );
};

export { SubMenu };
